import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventsService, PaymentV2Service, VariablesService, VwoService } from '../../../../shared/services';
import { IPaymentConfig } from '../../models/payment.model';
import { PaymentUtilService } from '../../services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit, OnDestroy {


  @Input() config;
  @Input() user;
  @Input() isLoading;
  @Input() isSipCause;
  @Input() amount;
  @Input() campaignId;
  @Input() currency;
  @Input() isAnonymous;
  @Input() disabled;
  @Input() payment_config: IPaymentConfig;
  @Output() isAnonymousChange = new EventEmitter();
  @Output() onSubmitBulk = new EventEmitter();
  @Output() onBtnClick = new EventEmitter();
  @Output() onEditClick = new EventEmitter();
  params;

  subs: Subscription[] = [];

  constructor(
    public paymentUtilService: PaymentUtilService,
    public events: EventsService,
    public vars: VariablesService,
    public vwo: VwoService,
    private actiRoute: ActivatedRoute,
    public paymentV2: PaymentV2Service
  ) {
  }

  ngOnInit(): void {
    this.setConfig();
    this.params = this.actiRoute.snapshot.queryParams;
  }

  setConfig() {
    this.subs.push(this.paymentUtilService.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
      }
    }));
  }

  onClickEdit() {
    this.events.sendSystemEvent({
      eventName: 'edit_donation_form',
      event_type: 'campaign',
      page_name: this.vars.pageName,
      event_type_id: this.vars.fundraiser.id,
    }).subscribe(_ => _);
    this.onEditClick.emit(true);
  }

  onSubmit() {
    this.onBtnClick.emit(true);
  }

  submitBulk = (e) => {
    this.onSubmitBulk.emit(e);
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
